import {IMessage} from '../api/interfaces/Messages/IMessage';
import {SiteURL, SiteURLUtils} from './site.url.utils';
import {
  ReservationValidationError, ReservationAuthorizationError
} from '../api/model/errors/reservation-error.model';
import {IAppConfig} from '../store/interfaces/IAppConfig';
import {ApplicationError} from '../api/model/errors/application-error.model';
import {MessageType} from '../api/model/message/message-type.model';
import {Translation} from '../api/interfaces/Translation/ITranslation';

const APPLICATION_NAME = 'staymanagement';
const DEFAULT_VIEW_NAME = 'common';

export class MessagesUtil {
  public static fromError(appConfig: IAppConfig, error: ApplicationError, defaultMessageKey): IMessage {
    let message: IMessage;
    if (error instanceof ReservationAuthorizationError) {
      const loginOrJoinParams = [SiteURLUtils.getLocalizedSiteUrl(appConfig, SiteURL.SIGN_IN),
                                SiteURLUtils.getLocalizedSiteUrl(appConfig, SiteURL.ENROLLMENT)];
      message = MessagesUtil.toErrorMessage(error.messageErrorCode, loginOrJoinParams, true);
    } else if (error instanceof ReservationValidationError) {
      const customerCareParam = [SiteURLUtils.getLocalizedSiteUrl(appConfig, SiteURL.CUSTOMER_CARE_WORLD_WIDE)];
      message = <IMessage>{key: error.messageErrorCode, params: customerCareParam};
    } else {
      const customerCareParams = [SiteURLUtils.getLocalizedSiteUrl(appConfig, SiteURL.CUSTOMER_CARE_WORLD_WIDE)];
      message = <IMessage>{key: defaultMessageKey, params: customerCareParams};
    }
    return message;
  }

  public static toErrorMessage(messageKey, params: string[] = [], dynamic = false, ) {
    return <IMessage>{key: messageKey, messageType: MessageType.ERROR, params: params, dynamic: dynamic};
  }

  public static toSuccessMessage(messageKey) {
    return <IMessage>{key: messageKey, messageType: MessageType.SUCCESS};
  }

  public static filterTranslations = (translations: Translation,  view: string = DEFAULT_VIEW_NAME) => {
    return Object.assign({}, MessagesUtil._filterByPrefix(translations.messages, APPLICATION_NAME + '.' + DEFAULT_VIEW_NAME), MessagesUtil._filterByPrefix(translations.messages, APPLICATION_NAME + '.' + view));
  }

  private static _filterByPrefix(messages: { [key: string]: string }, prefix: string): { [key: string]: string } {
    return Object.keys(messages)
      .filter(key => key.startsWith(prefix))
      .map(key => Object.assign({}, {[key.substring(prefix.length + 1)]: messages[key]}))
      .reduce((result, o) => Object.assign(result, o), {});
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/messages.util.ts